import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PromotionOchannelService } from '../../../services/promotion/promotion-ochannel.service';
import { FrontEndService } from '../../../services/front-end/front-end.service';
import { PromotionSystemService } from '../../../services/promotion-system/promotion-system.service';
import { CustomerSystemService } from '../../../services/customer-system/customer-system.service';
import { LoyaltySystemService } from '../../../services/loyalty-system/loyalty-system.service';
import { AnalyticsSystemService } from '../../../services/analytics-system/analytics-system.service';
import { BackofficeSystemService } from '../../../services/backoffice-system/backoffice-system.service';
import { CouponingSystemService } from '../../../services/couponing-system/couponing-system.service';

@Component({
  selector: 'app-store-configuration-period-form',
  templateUrl: './store-configuration-period-form.html',
  styleUrls: ['./store-configuration-period-form.css']
})
export class StoreConfigurationPeriodFormComponent implements OnInit, OnChanges {

  @Input() period: any = null;
  @Input() existingPeriods: any[] = [];
  @Input() showDialog = false;
  @Output() showDialogChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() periodSaved: EventEmitter<any> = new EventEmitter<any>();
  @Output() periodCancelled: EventEmitter<any> = new EventEmitter<any>();

  periodForm: FormGroup;
  overlapError = false;

  listFrontEndType: Array<{ label: string, value: any }> = [];
  listPromotionType: Array<{ label: string, value: any }> = [];
  listCustomerType: Array<{ label: string, value: any }> = [];
  listLoyaltyType: Array<{ label: string, value: any }> = [];
  listAnalyticType: Array<{ label: string, value: any }> = [];
  listBackOfficeType: Array<{ label: string, value: any }> = [];
  listCouponingType: Array<{ label: string, value: any }> = [];
  listChannel: Array<{ label: string, value: any }> = [];
  private channelList: any[] = [];

  constructor(
    private fb: FormBuilder,
    private srvOchannel: PromotionOchannelService,
    private srvFrontEnd: FrontEndService,
    private srvPromotion: PromotionSystemService,
    private srvCustomer: CustomerSystemService,
    private srvLoyalty: LoyaltySystemService,
    private srvAnalytics: AnalyticsSystemService,
    private srvBackoffice: BackofficeSystemService,
    private srvCouponing: CouponingSystemService
  ) {}

  ngOnInit() {
    this.loadDropdowns();
    this.buildOrPatchForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['period'] && !changes['period'].firstChange) {
      this.buildOrPatchForm();
    }
  }

  private toNumberOrNull(value: any): number | null {
    if (value === null || value === undefined || value === '') { return null; }
    const n = Number(value);
    return isNaN(n) ? null : n;
  }

  private parseDate(value: any): Date | null {
    if (!value) { return null; }
    if (value instanceof Date) { return isNaN(value.getTime()) ? null : value; }
    if (typeof value === 'string') {
      const dmy = value.match(/^(\d{2})-(\d{2})-(\d{4})$/);
      if (dmy) {
        const d = new Date(Number(dmy[3]), Number(dmy[2]) - 1, Number(dmy[1]));
        return isNaN(d.getTime()) ? null : d;
      }
    }
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  private formatDate(value: any): any {
    if (!value) { return null; }
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) { return null; }
    const month = ('0' + (d.getMonth() + 1)).slice(-2);
    const day = ('0' + d.getDate()).slice(-2);
    return d.getFullYear() + '-' + month + '-' + day;
  }

  get ambitoLabel(): string {
    if (this.period && this.period.store_or_division_name) { return this.period.store_or_division_name; }
    if (this.existingPeriods && this.existingPeriods.length > 0 && this.existingPeriods[0].store_or_division_name) {
      return this.existingPeriods[0].store_or_division_name;
    }
    return '';
  }

  get dialogTitle(): string {
    const base = 'Periodo di Configurazione';
    return this.ambitoLabel ? base + ' · ' + this.ambitoLabel : base;
  }

  buildOrPatchForm() {
    this.overlapError = false;
    let start = this.parseDate(this.period ? this.period.date_start : null);
    let end = this.parseDate(this.period ? this.period.date_end : null);
    if (!this.period && !start) {
      start = new Date();
    }
    const initial = {
      date_start: start,
      date_end: end,
      front_end_id: this.period ? this.toNumberOrNull(this.period.front_end_id) : null,
      promotion_id: this.period ? this.toNumberOrNull(this.period.promotion_id) : null,
      customer_id: this.period ? this.toNumberOrNull(this.period.customer_id) : null,
      loyalty_id: this.period ? this.toNumberOrNull(this.period.loyalty_id) : null,
      analytics_id: this.period ? this.toNumberOrNull(this.period.analytics_id) : null,
      backoffice_id: this.period ? this.toNumberOrNull(this.period.backoffice_id) : null,
      couponing_id: this.period ? this.toNumberOrNull(this.period.couponing_id) : null,
      ochannel_id: this.period ? this.toNumberOrNull(this.period.ochannel_id) : null
    };
    if (this.periodForm) {
      this.periodForm.patchValue(initial);
    } else {
      this.periodForm = this.fb.group({
        date_start: [initial.date_start, Validators.required],
        date_end: [initial.date_end, Validators.required],
        front_end_id: [initial.front_end_id],
        promotion_id: [initial.promotion_id],
        customer_id: [initial.customer_id],
        loyalty_id: [initial.loyalty_id],
        analytics_id: [initial.analytics_id],
        backoffice_id: [initial.backoffice_id],
        couponing_id: [initial.couponing_id],
        ochannel_id: [initial.ochannel_id]
      });
    }
  }

  isOverlapping(start: Date, end: Date): boolean {
    if (!start || !end || isNaN(start.getTime()) || isNaN(end.getTime())) { return false; }
    const currentId = this.period ? this.period.id : null;
    for (const p of this.existingPeriods || []) {
      if (currentId !== null && p.id === currentId) { continue; }
      const ps = this.parseDate(p.date_start);
      const pe = this.parseDate(p.date_end);
      if (!ps || !pe || isNaN(ps.getTime()) || isNaN(pe.getTime())) { continue; }
      if (start <= pe && end >= ps) { return true; }
    }
    return false;
  }

  private toIdOptions(items: any[]): Array<{ label: string, value: any }> {
    const options = [];
    for (const item of items || []) {
      if (item && item.name) {
        options.push({ label: item.name, value: Number(item.id) });
      }
    }
    return options;
  }

  private labelForId(list: Array<{ label: string, value: any }>, id: any): string | null {
    if (id === null || id === undefined || id === '') { return null; }
    const match = list.find(o => Number(o.value) === Number(id));
    return match ? match.label : null;
  }

  loadDropdowns() {
    this.srvFrontEnd.getAll().subscribe(
      res => { this.listFrontEndType = this.toIdOptions(res); },
      () => { this.listFrontEndType = []; }
    );
    this.srvPromotion.getAll().subscribe(
      res => { this.listPromotionType = this.toIdOptions(res); },
      () => { this.listPromotionType = []; }
    );
    this.srvCustomer.getAll().subscribe(
      res => { this.listCustomerType = this.toIdOptions(res); },
      () => { this.listCustomerType = []; }
    );
    this.srvLoyalty.getAll().subscribe(
      res => { this.listLoyaltyType = this.toIdOptions(res); },
      () => { this.listLoyaltyType = []; }
    );
    this.srvAnalytics.getAll().subscribe(
      res => { this.listAnalyticType = this.toIdOptions(res); },
      () => { this.listAnalyticType = []; }
    );
    this.srvBackoffice.getAll().subscribe(
      res => { this.listBackOfficeType = this.toIdOptions(res); },
      () => { this.listBackOfficeType = []; }
    );
    this.srvCouponing.getAll().subscribe(
      res => { this.listCouponingType = this.toIdOptions(res); },
      () => { this.listCouponingType = []; }
    );
    this.srvOchannel.list().subscribe(
      (res: any) => {
        this.channelList = res || [];
        const options = [];
        for (const item of this.channelList) {
          if (item && item.code) {
            options.push({ label: item.code, value: Number(item.id) });
          }
        }
        this.listChannel = options;
      },
      () => { this.channelList = []; this.listChannel = []; }
    );
  }

  save() {
    this.overlapError = false;
    if (this.periodForm.invalid) {
      Object.keys(this.periodForm.controls).forEach(key => {
        this.periodForm.get(key).markAsTouched();
      });
      return;
    }
    const formData = this.periodForm.value;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const start = formData.date_start ? new Date(formData.date_start) : null;
    const end = formData.date_end ? new Date(formData.date_end) : null;
    if (this.isOverlapping(start, end)) {
      this.overlapError = true;
      return;
    }
    let validity_status = 'ACTIVE';
    if (end && end < today) { validity_status = 'EXPIRED'; }
    else if (start && start > today) { validity_status = 'FUTURE'; }
    const selectedChannel = this.channelList.find(c => Number(c.id) === Number(formData.ochannel_id));
    const result = {
      id: this.period ? this.period.id : null,
      store_or_division_name: this.period ? this.period.store_or_division_name : null,
      front_end_name: this.labelForId(this.listFrontEndType, formData.front_end_id),
      promotion_name: this.labelForId(this.listPromotionType, formData.promotion_id),
      customer_name: this.labelForId(this.listCustomerType, formData.customer_id),
      loyalty_name: this.labelForId(this.listLoyaltyType, formData.loyalty_id),
      analytics_name: this.labelForId(this.listAnalyticType, formData.analytics_id),
      backoffice_name: this.labelForId(this.listBackOfficeType, formData.backoffice_id),
      couponing_name: this.labelForId(this.listCouponingType, formData.couponing_id),
      ochannel_code: selectedChannel ? selectedChannel.code : null,
      ochannel_description: selectedChannel ? selectedChannel.description : null,
      ...formData,
      date_start: this.formatDate(formData.date_start),
      date_end: this.formatDate(formData.date_end),
      validity_status: validity_status
    };
    this.periodSaved.emit(result);
  }

  cancel() {
    this.showDialog = false;
    this.showDialogChange.emit(false);
    this.periodCancelled.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store-configuration/store-configuration-period-form.component.ts